
<!--  -->
<template>
  <div>
    <!-- 下载状态 -->
    <i :class="downStatus"></i>
    <span class="file-name">{{ itemData.fileName }}</span>
    {{ itemData }}
    <span class="cur-down-progress">{{ itemData.loaded }}</span>
    <span class="sum-down-progress" v-show="itemData.size">
      / {{ itemData.size }}</span
    >
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      itemData: {}, // item数据
    };
  },
  props: {
    data: Object, // item数据
  },
  computed: {
    downStatus() {
      console.log(this.data, this.data.loaded);
      return this.data.done ? "el-icon-success" : "el-icon-loading";
    },
  },
  methods: {
    changeItemData() {
      console.log(123, this.data);
      this.itemData = this.data;
    },
  },
  watch: {
    data: {
      handler(newValue) {
        this.itemData = newValue;
        // console.log(123);
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang='scss' scoped>
</style>
